module.exports = __webpack_public_path__ + "static/media/yellowhead-18.e8d334f0.jpg";